<template>
    <f-dialog
        v-if="contract"
        v-model       = "show"
        :title         = "'Vertragsänderungen Anlage ' + (unit ? unit.fabricNo : '') + (contract ? (' - ' + contract.type.name) : null)"
        :show-header  = true
        :hide-actions = "true"
        :width        = "width"
        :show-save    = "false"
        @cancel       = "onCancel"
    >
        <template v-slot:content>
            <div v-if="!history || history.length === 0" class="mt-5 mb-5">
                Keine Änderungen
            </div>

            <div v-if="history && history.length > 0">
                <div class="mt-3 mb-4 ml-1">
                    <div class=" v-flex unit-history history-header">
                        <div class="action-date primary--text">
                            {{ $t("contract.modified.at") }}
                        </div>

                        <div class="action-user primary--text">
                            {{ $t("contract.modified.by") }}
                        </div>

                        <div class="contract-action primary--text">
                            {{ $t("contract.action") }}
                        </div>

                        <div class="contract primary--text">
                            {{ $t("contract.title") }}
                        </div>

                        <div class="contract-company primary--text">
                            {{ $t("contract.partner") }}
                        </div>

                        <div class="contract-date primary--text">
                            {{ $t("contract.start") }}
                        </div>
                        <div class="contract-date primary--text">
                            {{ $t("contract.expiration") }}
                        </div>

                        <div class="contract-terminate primary--text" v-if="isMnt">

                        </div>


                        <div class="unit-value primary--text" v-if="isMnt">
                            {{ $t("contract.mnt.costsPerYear") }}
                        </div>

                        <div class="unit-value primary--text" v-if="isMnt" style="width: 120px">
                            {{ $t("contract.mnt.countPerYear") }}
                        </div>

                        <div class="unit-value primary--text" v-if="isEsc">
                            {{ $t("contract.esc.costs") }}
                        </div>

                        <div class="unit-value primary--text" v-if="isEsc">
                            {{ $t("contract.esc.gadgetRent") }}
                        </div>

                        <div class="unit-value primary--text" v-if="isEsc">
                            {{ $t("contract.esc.rentPerYear") }}
                        </div>

                        <div class="unit-value primary--text" v-if="isEsc">
                            {{ $t("contract.esc.standByPerYear") }}
                        </div>

                        <div class="unit-value primary--text" v-if="isEsc">
                            {{ $t("contract.esc.phoneCosts") }}
                        </div>

                        <div class="unit-value primary--text" v-if="isEsc">
                            {{ $t("contract.esc.guardCosts") }}
                        </div>

                        <div class="unit-value primary--text" v-if="isDls">
                            {{ $t("contract.dls.netamount") }}
                        </div>

                        <div class="unit-value primary--text" v-if="isDls">
                            {{ $t("contract.dls.grossamount") }}
                        </div>

                        <div class="unit-zus-value primary--text" v-if="isZus">
                            {{ $t("contract.zus.costsMainAudit") }}
                        </div>

                        <div class="unit-zus-value primary--text" v-if="isZus">
                            {{ $t("contract.zus.costIntermediateAudit") }}
                        </div>

                        <div class="unit-zus-value primary--text" v-if="isZus">
                            {{ $t("contract.zus.costAuditAfterChange") }}
                        </div>

                        <div class="unit-zus-value primary--text" v-if="isZus" style="width: 150px;">
                            {{ $t("contract.zus.costAuditAfterDefects") }}
                        </div>
                    </div>
                    <div style="max-height: 500px; overflow-y: scroll">
                        <div v-for="(entry, index) in history" :key = "index">
                            <div class="v-flex unit-history pa-2">
                                <div class="action-date">
                                    {{ formatDateTime(entry.modifiedDate) }}
                                </div>

                                <div class="action-user">
                                    {{ entry.modifiedBy  }}
                                </div>

                                <div class="contract-action">
                                    {{ formatModType (entry.modType) }}
                                </div>

                                <div class="contract">
                                    {{ entry.contractId }}
                                </div>

                                <div class="contract-company">
                                    {{ entry.company.name }}
                                </div>

                                <div class="contract-date">
                                    {{ formatDate(entry.start) }}
                                </div>
                                <div class="contract-date">
                                    {{ formatDate(entry.end) }}
                                </div>

                                <div class="contract-terminate">
                                    <v-icon v-if="entry.terminate" size="24" color="error" style="margin-top: -2px;">mdi-close-octagon</v-icon>
                                </div>

                                <div v-if="isMnt || isEsc" class="unit-value">
                                    {{ formatAmount (entry.costs) }}
                                </div>

                                <div v-if="isMnt" class="unit-value"  style="width: 120px">
                                    {{ entry.count }}
                                </div>

                                <div v-if="isEsc" class="unit-value">
                                    {{ entry.gadget ? entry.gadget.name : "---" }}
                                </div>

                                <div v-if="isEsc" class="unit-value">
                                    {{ formatAmount (entry.rent) }}
                                </div>

                                <div v-if="isEsc" class="unit-value">
                                    {{ formatAmount (entry.standBy) }}
                                </div>

                                <div v-if="isEsc" class="unit-value">
                                    {{ formatAmount (entry.phoneCosts) }}
                                </div>

                                <div v-if="isEsc" class="unit-value">
                                    {{ formatAmount (entry.guardCosts) }}
                                </div>

                                <div v-if="isDls" class="unit-value">
                                    {{ formatAmount (entry.grossamount) }}
                                </div>

                                <div v-if="isDls" class="unit-value">
                                    {{ formatAmount (entry.netamount) }}
                                </div>

                                <div v-if="isZus" class="unit-zus-value">
                                    {{ formatAmount (entry.mainAudit) }}
                                </div>

                                <div v-if="isZus" class="unit-zus-value">
                                    {{ formatAmount (entry.intermediateAudit) }}
                                </div>

                                <div v-if="isZus" class="unit-zus-value">
                                    {{ formatAmount (entry.auditAfterChange) }}
                                </div>

                                <div v-if="isZus" class="unit-zus-value" style="width: 150px;">
                                    {{ formatAmount (entry.auditAfterDefects)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </f-dialog>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import FDialog        from "@/modules/core/components/utils/FDialog.vue";

export default {
    name: "DContractHistory",

    components: {
        FDialog
    },

    props: {
        unit: {

        },

        value: {

        },

        contract: {

        },


        history: {

        }
    },

    data: () => ({
        show    : false,
    }),

    computed: {
        isMnt () {
            return this.contract.type.id === 3;
        },

        isEsc () {
            return this.contract.type.id === 4;
        },

        isLim () {
            return this.contract.type.id === 1;
        },

        isDls () {
            return this.contract.type.id === 2;
        },

        isZus () {
            return this.contract.type.id === 5;
        },

        width () {
            if (this.isLim) return 800;
            if (this.isDls) return 1000;
            if (this.isMnt) return 1000;
            if (this.isEsc) return 1400;
            if (this.isZus) return 1300;
            return 600;
        },
    },

    mounted() {
        this.show = this.value;
    },

    watch: {
        value() {
            this.show = this.value;
        },
    },

    methods: {
        formatDate (value) {
            if (!value) {
                return "---";
            }

            return Core.format.date.display(value)
        },

        formatModType (modType) {
            return this.$t("contract.modType." + modType)
        },

        formatDateTime (value) {
            return Core.format.datetime.display(value)
        },

        formatAmount (value) {
            if (!value) {
                return "---";
            }

            return Core.format.money(value)
        },

        onCancel () {
            this.$emit("input", false);
        }
    }
}
</script>

<style scoped>

.unit-history {
    font-size: 16px;
    margin-top: 4px;
}

.history-header {
    font-size: 12px;
    padding-left: 8px;
}

.unit-history .contract-action {
    text-align: left;
    width: 120px;
    min-width: 120px;
}

.unit-history .contract {
    width: 70px;
    min-width: 70px;
}

.unit-history .action-date {
    width: 140px;
    min-width: 140px;
    max-width: 140px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.unit-history .action-user {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.contract-terminate {
    width: 50px;
    text-align: center;
}

.unit-history .contract-date {
    width: 95px;
}

.unit-value {
    width: 95px;
    min-width: 95px;
    text-align: right;
}

.unit-zus-value {
    width: 120px;
    min-width: 120px;
    text-align: right;
}


.contract-company {
    width: 140px;
    min-width: 140px;
    max-width: 140px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

</style>